import { render, staticRenderFns } from "./_cv-side-nav-link-text.vue?vue&type=template&id=855a379e&"
import script from "./_cv-side-nav-link-text.vue?vue&type=script&lang=js&"
export * from "./_cv-side-nav-link-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports